import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    applyCollaborationInvite: {
        route: "/workspaces/collaboration-invites/:inviteId/apply",
        method: "POST"
    }
};
